module.exports = __webpack_public_path__ + "static/5-870e9c704f905bf5d82167a58da52107.jpg";